import useSWR from "swr";

const useFetchWithCondition = (key, fetcher, condition) => {
  return useSWR(condition ? key : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
};

export default useFetchWithCondition;
